var THREE = require('three/src/Three');
let camera;
let scene;
let renderer;
let isUserInteracting = false;
let onPointerDownMouseX = 0;
let onPointerDownMouseY = 0;
let lon = 0;
let onPointerDownLon = 0;
let lat = 0;
let onPointerDownLat = 0;
let phi = 0;
let theta = 0;
let isPaused = false;
let pauseDuration = 6000;
/**
 *
 *
 */
function animate() {
    if (!isUserInteracting && !isPaused) {
        lon += 0.05;
    }
    lat = Math.max( - 85, Math.min( 85, lat ) );
    phi = THREE.MathUtils.degToRad( 90 - lat );
    theta = THREE.MathUtils.degToRad( lon );
    const x = 500 * Math.sin( phi ) * Math.cos( theta );
    const y = 500 * Math.cos( phi );
    const z = 500 * Math.sin( phi ) * Math.sin( theta );
    camera.lookAt( x, y, z );
    renderer.render( scene, camera );
}
/**
 *
 *
 */
function pauseAnimation() {
    isPaused = true;
    $(".icon-move").fadeOut("slow");

    setTimeout(() => {
        isPaused = false;
        $(".icon-move").fadeIn("slow");
    }, pauseDuration);
}
/**
 *
 *
 */
function onImageClick() {
    pauseAnimation();
}

$('#three-container').on('click', function (e) {
    onImageClick()
})
/**
* Function to pointer move
* @param {Object} event Pointer move
*/
function onPointerMove(event) {
    if (!event.isPrimary) return;
    lon = ( onPointerDownMouseX - event.clientX ) * 0.1 + onPointerDownLon;
    lat = ( event.clientY - onPointerDownMouseY ) * 0.1 + onPointerDownLat;
}

/**
* Function to pointer up
* @param {Object} event Pointer up
*/
function onPointerUp(event) {
    if (!event.isPrimary) return;
    isUserInteracting = false;
    document.removeEventListener( 'pointermove', onPointerMove );
    document.removeEventListener( 'pointerup', onPointerUp );
}

/**
* Function to pointer with mouse
* @param {Object} event Pointer in 360 image
*/
function onPointerDown( event ) {
    if (!event.isPrimary) return;
    isUserInteracting = true;
    onPointerDownMouseX = event.clientX;
    onPointerDownMouseY = event.clientY;
    onPointerDownLon = lon;
    onPointerDownLat = lat;
    document.addEventListener( 'pointermove', onPointerMove );
    document.addEventListener( 'pointerup', onPointerUp );
}

/**
 *
 *
 */
function onWindowResize() {
    const container = document.getElementById('three-container');
    camera.aspect = container.clientWidth / container.clientHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(container.clientWidth, container.clientHeight);
}

/**
 *
 *
 */
function init() {
    const container = document.getElementById('three-container');
    camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 1100 );
    scene = new THREE.Scene();
    const geometry = new THREE.SphereGeometry( 500, 60, 40 );
    // invert the geometry on the x-axis so that all of the faces point inward
    geometry.scale( - 1, 1, 1 );
    const imageSrc = container.getAttribute('data-src');
    const texture = new THREE.TextureLoader().load(imageSrc);
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.generateMipmaps = false;
    texture.colorSpace = THREE.SRGBColorSpace;
    const material = new THREE.MeshBasicMaterial( { map: texture } );
    const mesh = new THREE.Mesh( geometry, material );
    scene.add( mesh );
    renderer = new THREE.WebGLRenderer();
    renderer.setPixelRatio( window.devicePixelRatio );
    renderer.setSize( window.innerWidth, window.innerHeight );
    renderer.setAnimationLoop( animate );
    container.appendChild( renderer.domElement );
    container.style.touchAction = 'none';
    container.addEventListener( 'pointerdown', onPointerDown );
    /* eslint-disable no-param-reassign */
    document.addEventListener( 'dragover', function (event) {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    });
    /* eslint-enable no-param-reassign */

    document.addEventListener( 'dragenter', function () {
        document.body.style.opacity = 0.5;
    });

    document.addEventListener( 'dragleave', function () {
        document.body.style.opacity = 1;
    });

    document.addEventListener( 'drop', function ( event ) {
        event.preventDefault();
        const reader = new FileReader();
        reader.addEventListener( 'load', function () {
            material.map.image.src = event.target.result;
            material.map.needsUpdate = true;
        } );
        reader.readAsDataURL( event.dataTransfer.files[ 0 ] );
        document.body.style.opacity = 1;
    } );
    window.addEventListener('resize', onWindowResize);
}

document.addEventListener('DOMContentLoaded', function () {
    let scale = 1;
    const scaleStep = 0.2;
    const maxScale = 3;
    const minScale = 1;
    const image = document.getElementById('three-container');
    image.style.transform = `scale(${scale})`;    
    const zoomInButton = document.getElementById('zoom-in-button');
    const zoomOutButton = document.getElementById('zoom-out-button');
    /**
    *
    */
    function updateImageTransform() {
        image.style.transform = `scale(${scale})`;
    }

    $('#threeModal').on('shown.bs.modal', function (e) {
        scale = 1;
        updateImageTransform();
        document.body.classList.add('body-bloqued');
    })

    $('#threeModal').on('hidden.bs.modal', function (e) {
        document.body.classList.remove('body-bloqued');
    });
    
    $(".recorrido-virtual-btn").on('click', function (e) {
        scale = 1;
        image.style.transform = `scale(${scale})`;

        setTimeout(() => {
            onWindowResize();
            updateImageTransform();
        }, 1500);
    });

    zoomInButton.addEventListener('click', function () {
        if (scale < maxScale) {
            scale += scaleStep;
            updateImageTransform();
        }
    });

    zoomOutButton.addEventListener('click', function () {
        if (scale > minScale) {
            scale -= scaleStep;
            updateImageTransform();
        }
    });
});
init();